module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Plan\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "raw": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Plan name"
    },
    model: {
      value: (_vm.modelName),
      callback: function($$v) {
        _vm.modelName = $$v
      },
      expression: "modelName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Plan price",
      "type": "number",
      "prefix": "$",
      "persistent-hint": "",
      "suffix": _vm.selectedCasket ? '+ casket price $ ' + _vm.casketById(_vm.selectedCasket).price : ''
    },
    model: {
      value: (_vm.planPrice),
      callback: function($$v) {
        _vm.planPrice = $$v
      },
      expression: "planPrice"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "label": "Select Casket Model",
      "clearable": ""
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.products,
      "hide-selected": "",
      "multiple": "",
      "persistent-hint": "",
      "small-chips": "",
      "label": "Select Products"
    },
    model: {
      value: (_vm.selectedProducts),
      callback: function($$v) {
        _vm.selectedProducts = $$v
      },
      expression: "selectedProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [(_vm.selectedProducts && _vm.selectedProducts.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedProducts,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.amount) + "\n                  "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "label": "Quantity"
          },
          slot: "input",
          model: {
            value: (props.item.amount),
            callback: function($$v) {
              _vm.$set(props.item, "amount", $$v)
            },
            expression: "props.item.amount"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))])]
      }
    }], null, false, 797219097)
  }) : _vm._e()], 1), _vm._v(" "), (_vm.totalPrice > 0) ? _c('span', [_c('b', [_vm._v("Total price: $" + _vm._s(_vm.totalPrice || 0))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b55509","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddPlanButton.vue
// module id = 934
// module chunks = 1